import { useEffect } from "react";
import { X } from "lucide-react";

export function Lightbox({ src, onClose }) {
  useEffect(() => {
    if (!src) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [src, onClose]);

  if (!src) return null;
  return (
    <div data-testid="lightbox" className="fixed inset-0 z-[100] bg-obsidian/95 backdrop-blur-xl flex items-center justify-center p-4 sm:p-10" onClick={onClose}>
      <button data-testid="lightbox-close" className="absolute top-6 right-6 text-white hover:text-ember transition-colors" onClick={onClose}><X size={28} /></button>
      <img src={src} alt="Tattoo detail" className="max-w-full max-h-full object-contain border border-ash" onClick={(e) => e.stopPropagation()} />
    </div>
  );
}
